export { CheckIcon } from "./check";
export { ReviewIcon } from "./review";
export { StarAltIcon } from "./star-alt";
export { GoogleIcon } from "./google";
export { ReviewsIcon } from "./reviews";
export { TrustPilotIcon } from "./trustpilot";
export { WpmudevIcon } from "./wpmudev";
